import { render, staticRenderFns } from "./Vincular.vue?vue&type=template&id=2464f3aa&scoped=true"
import script from "./Vincular.vue?vue&type=script&lang=js"
export * from "./Vincular.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=2464f3aa&prod&scoped=true&lang=css&external"
import style1 from "./Vincular.vue?vue&type=style&index=1&id=2464f3aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2464f3aa",
  null
  
)

export default component.exports